
import { Component, Vue } from "vue-property-decorator";
import ScreenVideoTep from "@/template/screen/ScreenVideo.vue";
@Component
export default class ScreenVideo extends ScreenVideoTep {}
